<template>
	<div class="keyboard-help bg-shade-2 absolute z-10 p-4">
		<button class="button button--secondary" @click="focusFirstTreeItem">{{ resources?.SkipToFormList || 'Skip to Form List' }}</button>
	</div>
</template>

<script lang="ts">
	import { focusFirstItem } from 'src/composables/use-keyboard-nav';
	import { localizationResourcesKey } from 'src/utilities/injection-keys';
	import { defineComponent, inject } from 'vue';

	export default defineComponent({
		name: 'CKeyboardHelp',
		setup() {
			return {
				resources: inject(localizationResourcesKey),
				focusFirstTreeItem: focusFirstItem
			};
		}
	});
</script>

<style lang="scss">
.keyboard-help {
	opacity: 0;
	pointer-events: none;

	&:focus-within {
		opacity: 1;
	}

	*:focus {
		outline: 1px solid var(--outline-focused);
	}

	.admin--nav-collapsed:not(.admin--nav-overlay) & {
		display: none;
	}
}
</style>